export class ExportOrdersRequest {
  public exportFileName: string;

  public exportExcel: boolean;
  public exportConsignmentNote: boolean;
  public exportPhoto: boolean;
  public exportDocument: boolean;
  public exportRoadMap: boolean;

  public isAssigned: boolean;
  public orderIds: string[] = [];
  public includePrices: boolean;

  public filters: ExportOrderFilters;

  constructor() {
    this.filters = new ExportOrderFilters();
  }

  public generateFileName(): void {
    let fileName = 'export_';

    fileName = fileName + this._getSelectedTypes();
    fileName += new Date().toISOString().slice(0, 10);

    this.exportFileName = fileName;
  }

  private _allTypesSelected(): boolean {
    return (
      this.exportExcel &&
      this.exportConsignmentNote &&
      this.exportPhoto &&
      this.exportDocument &&
      !this.exportRoadMap
    );
  }

  private _getSelectedTypes(): string {
    let selectedTypes: string = '';
    if (this._allTypesSelected()) {
      return selectedTypes;
    }

    if (this.exportExcel) {
      selectedTypes += 'details-missions_';
    }
    if (this.exportConsignmentNote) {
      selectedTypes += 'lettre-de-voiture_';
    }
    if (this.exportPhoto) {
      selectedTypes += 'photos_';
    }
    if (this.exportDocument) {
      selectedTypes += 'documents_';
    }
    if (this.exportRoadMap) {
      selectedTypes += 'roadmap_';
    }
    return selectedTypes;
  }

  public isOnlyExcelSelected(): boolean {
    return (
      this.exportExcel &&
      !this.exportConsignmentNote &&
      !this.exportPhoto &&
      !this.exportDocument &&
      !this.exportRoadMap
    );
  }
}

export class ExportOrderFilters {
  public filters: string;
  public sorts: string;
  public page: number;
  public pageSize: number;
}
